<template>
  <div id="app">
    <!--
      iframe 纯净模式：直接渲染客服组件，完全不走 router-view。
      彻底消除 hash 异步解析导致的 / → /customer-service 路由跳转。
      其他 iframe 也是这么做的——不把 widget 嵌进 SPA 路由里。
    -->
    <template v-if="isBareMode">
      <CustomerWidget />
    </template>

    <!-- 正常商城模式 -->
    <template v-else>
      <keep-alive include="product">
        <router-view />
      </keep-alive>

      <SideFloatBar ref="floatBar" :cartCount="cartCount" :customBadges="customBadges" />
      <CustomerService />
    </template>

  </div>
</template>
<script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>

<script>
import { shopConfigGetData, getUserInfo } from "@/api/member"; //获取基本信息
import { shoppingCartGetCount } from "@/api/product";
import Bus from "@/utils/bus"; //兄弟组件之间的事件总线
import SideFloatBar from "@/components/sideFloatBar.vue"; //右侧悬浮侧边栏
import CustomerService from "@/components/customerService.vue"; //右侧悬浮侧边栏
const CustomerWidget = () => import("./views/customerWidget.vue"); //iframe 客服组件（懒加载）
export default {
  data() {
    return {
      cartCount: null,
      customBadges: null,
      basicInfo: null, //获取基本信息
    };
  },
  computed: {
    // iframe 内嵌 → 直接渲染客服组件，不走路由
    // 浏览器直接访问 /#/customer-service → 也走纯净模式（兜底）
    isBareMode() {
      return window.self !== window.top || this.$route.meta.bare;
    },
  },
  mounted() {
    if (this.isBareMode) return;
    // 注册事件监听
    Bus.$on("sendData", this.handleMessage);
    this.init();
  },
  methods: {
    async init() {
      // 获取购物车数量
      await shoppingCartGetCount().then((res) => {
        this.cartCount = res;
      });

      // 获取基本信息
      await shopConfigGetData().then((res) => {
        this.basicInfo = res;
        localStorage.setItem("basicInfo", JSON.stringify(res));
      });
    },

    handleMessage(payload) {
      this.$refs.floatBar.startFly(payload.target);
      this.cartCount = payload.cartCount;
      this.customBadges = payload.customBadges;
    },
  },
  beforeDestroy() {
    Bus.$off("sendData", this.handleMessage);
  },
  components: {
    SideFloatBar,
    CustomerService,
    CustomerWidget,
  },
};
</script>
>
<style lang="less">
/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}*/

@media only screen and (max-width: 767px) {
  .el-message-box {
    width: 90%;
  }

  .el-message {
    width: 90%;
    min-width: auto;
  }
}
</style>
